<template>
  <v-card fluid>
    <v-card-title class="blue darken-3"
    style="padding-top: 2px; padding-bottom: 2px; padding-right: 2px;"">
      <span class="text-h5 white--text">FULL Spectrum (VISION)</span>

      <v-spacer />

      <!-- Logo à droite -->

      <v-img
        src="/etc/img/VISION.png"
        alt="Néo-NARVAL"
        contain
        max-width="109"
        max-height="50"
        class="ml-2"
      />

            
    </v-card-title>

    <v-banner></v-banner>

    <v-row align="baseline">
      <v-col cols="8">
        <v-text-field
          v-model="target.objet"
          :rules="mandatoryRules"
          label="Objet Name"
          class="required"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-btn
          color="primary"
          class="ma-2"
          :loading="v_loading"
          dark
          @click='Simbad(target.objet)'
        >Simbad
        </v-btn>
      </v-col>

    </v-row>

    <v-divider></v-divider>

    <v-row align="baseline">
      <v-col cols="8" md="2">
        <v-text-field
          v-model="target.magv"
          type="number"
          :rules="mandatoryRules"
          label="Mag.V"
          class="required"
        ></v-text-field>
      </v-col>
      <v-col cols="8" md="2" v-if="false">
        <v-text-field
          v-model="target.magb"
          type="number"
          :rules="mandatoryRules"
          label="Mag.B"
          class="required"
        ></v-text-field>
      </v-col>
      <v-col cols="8" md="2">
        <v-text-field
          v-model="target.magh"
          type="number"
          :rules="mandatoryRules"
          label="Mag.H"
          class="required"
        ></v-text-field>
      </v-col>
      <v-col cols="8" md="2">
        <v-text-field
          v-model="target.temperature"
          type="number"
          :rules="mandatoryRules"
          label="Tₑff (K)"
          class="required"
        ></v-text-field>
      </v-col>

      <v-col
        cols="7"
        md="2"
      >

        <v-text-field
          v-model= "sn"
          type= "number"
          label= "S/N"
          required
        ></v-text-field>

      </v-col>

      <v-col
        cols="12"
        md="2"
      >
        <v-btn
            color="primary"
            class="ma-2"
            :loading="v_loading"
            dark
            @click='ETCs_Submit()'
          >ETCs Submit (SPIP Master) 
        </v-btn>
      </v-col>






    </v-row>

    <v-row align="baseline" v-if="false">
      <v-col cols="8" md="2">
        <v-text-field
          v-model="target.magv"
          type="number"
          :rules="mandatoryRules"
          label="Mag.V"
          class="required"
        ></v-text-field>
      </v-col>
      <v-col cols="8" md="2" v-if="false">
        <v-text-field
          v-model="target.magb"
          type="number"
          :rules="mandatoryRules"
          label="Mag.B"
          class="required"
        ></v-text-field>
      </v-col>
      <v-col cols="8" md="2">
        <v-text-field
          v-model="target.magh"
          type="number"
          :rules="mandatoryRules"
          label="Mag.H"
          class="required"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row align="baseline" v-if = "false">
      <v-col cols="8" md="2" v-if = "false">
        <v-text-field
          v-model="target.spectype"
          :rules="mandatoryRules"
          readonly
          label="SpecType"
          class="required"
        ></v-text-field>
      </v-col>
      <v-col cols="8" md="2">
        <v-text-field
          v-model="target.temperature"
          type="number"
          readonly
          :rules="mandatoryRules"
          label="Tₑff (K)"
          class="required"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if = "false">

      <v-col
        cols="7"
        md="2"
      >

        <v-text-field
          v-model= "sn"
          type= "number"
          label= "S/N"
          required
        ></v-text-field>

      </v-col>

      <v-col
        cols="12"
        md="2"
      >
        <v-btn
            color="primary"
            class="ma-2"
            :loading="v_loading"
            dark
            @click='ETC_SPIS_Submit()'
          >ETCs Submit (SPIP Master) 
        </v-btn>

      </v-col>
    </v-row>  

    <v-banner v-if = "false"></v-banner>
    <v-divider></v-divider>

      <v-row>
        <v-col
          cols="7"
          md="2"
        >


        </v-col>
      </v-row>

    <v-row>
      <v-img
        src="/etc/img/NEO-NARVAL.png"
        alt="Néo-NARVAL"
        contain
        max-width="109"
        max-height="50"
        class="ml-2"
      />

      <v-col
        cols="7"
        md="2"
      >

        <v-text-field
          v-model= "exposure_neo"
          type= "number"
          label= "Exposure"
          readonly
        ></v-text-field>

      </v-col>
      <v-col
        cols="7"
        md="2"
      >


      <v-text-field
          v-model= "npictures_neo"
          type= "number"
          label= "N Pictures"
          readonly
        ></v-text-field>

      </v-col>

      <v-col
        cols="12"
        md="2"
      >

        <v-text-field
          v-model= "mode_neo"
          type="text"
          label="Camera Mode"
          readonly
        ></v-text-field>

      </v-col>
      <v-col
        cols="12"
        md="2"
      >

        <v-text-field
          v-model= "sn_res_neo"
          type="number"
          label="S/N)"
          readonly
        ></v-text-field>
      
      </v-col>
      <v-col
        cols="12"
        md="2"
      >

        <v-text-field
          v-model= "total_time_neo"
          type="number"
          label="Total Time"
          readonly
        ></v-text-field>

      </v-col>
      <v-col
        cols="12"
        md="2"
      >


      </v-col>


    </v-row>  

    <v-row>
      <v-img
        src="/etc/img/SPIP.png"
        alt="Néo-NARVAL"
        contain
        max-width="109"
        max-height="50"
        class="ml-2"
      />

      <v-col
        cols="7"
        md="2"
      >

        <v-text-field
          v-model= "exposure_spip"
          type= "number"
          label= "Exposure"
          readonly
        ></v-text-field>

      </v-col>
      <v-col
        v-if = "false"
        cols="7"
        md="2"
      >


      <v-text-field
          v-model= "npictures_spip"
          type= "number"
          label= "N Pictures"
          readonly
        ></v-text-field>

      </v-col>

      <v-col
        cols="12"
        md="2"
        v-if = "false"
      >

        <v-text-field
          v-model= "mode_spip"
          type="text"
          label="Camera Mode"
          readonly
        ></v-text-field>

      </v-col>
      <v-col
        cols="12"
        md="2"
        v-if = "false"
      >

        <v-text-field
          v-model= "sn_res_spip"
          type="number"
          label="S/N)"
          readonly
        ></v-text-field>
      
      </v-col>
      <v-col
        cols="12"
        md="2"
        v-if = "false"
      >

        <v-text-field
          v-model= "total_time_spip"
          type="number"
          label="Total Time"
          readonly
        ></v-text-field>

      </v-col>
      <v-col
        cols="12"
        md="2"
      >


      </v-col>


    </v-row>  


  </v-card>
</template>





<script>
  export default {
    data: () => ({

      v_loading : false,

      objet : "",

      target : {
        spectype: "-",
        objet: "",
        realname: "",
        alpha: "hh mm ss.ss",
        delta: "+dd mm ss.ss",
        magv: 0,
        magb: 0,
        magh: 0,
        pm_ra: 0,
        pm_dec: 0,
        equ: 2000,
        ephemeris: false,
        temperature: 2.7,
        lock: "false",
      },
      magv:1,
      sn: 100,
      teff : 1500,

      exposure_neo: 0,
      npictures_neo: 0,
      mode_neo : "",
      sn_res_neo :0,
      total_time_neo : 0,

      exposure_spip: 0,
      npictures_spip: 0,
      mode_spip : "",
      sn_res_spip :0,
      total_time_spip : 0,
      
      
      dialog: false,
      dialog2: false,
      dialog3: false,




    }),
    initialize(){
      //this.Fill_tab();
    },
    created(){
      //this.Fill_Tab();
    },
    beforeMount(){

    },
    mounted(){
      //this.Fill_Tab();
    },

    methods: {

      Simbad(obj) {
        this.v_loading = true;

        this.axios
          .get(
            `https://api.sedoo.fr/sedoo-northstar-rest/target/v1_0/information?identifier=` +
              obj +
              `&historicalFormat=true`
          )
          .then((res) => {
            this.target = res.data;
            //console.log(target);
            this.v_loading = false;
          })
          .catch((err) => {
            console.warn(err);
            this.v_loading = false;
          });
      },
      ETCs_Submit(){

        this.v_loading = true;
        console.log("go");
        var url = "https://api.sedoo.fr/sedoo-northstar-rest/etc/v1_0/computeNeonarvalEtcWithTeff?vMagnitude="+this.target.magv+"&tEff="+this.target.temperature+"&signalToNoise="+this.sn;
        
        axios.get(url)
        .then(res => {
          //console.log(res.data.solutions[0]);
          var res_etc = res.data.solutions[0]
          
          this.exposure_neo = res_etc.exposureTime;
          this.npictures_neo = res_etc.imageNumber;
          this.mode_neo = res_etc.mode;
          this.sn_res_neo = res_etc.sn;
          this.total_time_neo = res_etc.totalExposureTime;

          this.v_loading = false;
        })
        .catch(error => {
          console.log(error)
          this.exposure = 9999999;
          this.mode = "Error";
          this.v_loading = false;
        })      
      },

      ETC_NARVAL_Submit(){

        this.v_loading = true;
        var url = "https://api.sedoo.fr/sedoo-northstar-rest/etc/v1_0/computeNeonarvalEtcWithTeff?vMagnitude="+this.target.magv+"&tEff="+this.target.temperature+"&signalToNoise="+this.sn;
        
        axios.get(url)
        .then(res => {
          //console.log(res.data.solutions[0]);
          var res_etc = res.data.solutions[0]
          
          this.exposure = res_etc.exposureTime;
          this.npictures = res_etc.imageNumber;
          this.mode = res_etc.mode;
          this.sn_res = res_etc.sn;
          this.total_time = res_etc.totalExposureTime;

          this.v_loading = false;
        })
        .catch(error => {
          console.log(error)
          this.exposure = 9999999;
          this.mode = "Error";
          this.v_loading = false;
        })      
      },
      ETC_SPIP_Submit(){

        this.v_loading = true;
        var url = "https://api.sedoo.fr/sedoo-northstar-rest/etc/v1_0/computeNeonarvalEtcWithTeff?vMagnitude="+this.target.magv+"&tEff="+this.target.temperature+"&signalToNoise="+this.sn;
        
        axios.get(url)
        .then(res => {
          //console.log(res.data.solutions[0]);
          var res_etc = res.data.solutions[0]
          
          this.exposure = res_etc.exposureTime;
          this.npictures = res_etc.imageNumber;
          this.mode = res_etc.mode;
          this.sn_res = res_etc.sn;
          this.total_time = res_etc.totalExposureTime;

          this.v_loading = false;
        })
        .catch(error => {
          console.log(error)
          this.exposure = 9999999;
          this.mode = "Error";
          this.v_loading = false;
        })      
        //alert(url);
      }
  }
}
</script>